import axios from 'axios'

const API = `${process.env.REACT_APP_BACKEND_URL}/api`

// Dashboard
export const getDashboard = () => axios.get(`${API}/dashboard`)

// Processos
export const getProcessos = (status) => axios.get(`${API}/processos`, { params: { status } })
export const getProcesso = (id) => axios.get(`${API}/processos/${id}`)
export const createProcesso = (data) => axios.post(`${API}/processos`, data)
export const updateProcesso = (id, data) => axios.put(`${API}/processos/${id}`, data)
export const deleteProcesso = (id) => axios.delete(`${API}/processos/${id}`)
export const marcarProntoPagamento = (id, fonte_recurso, previsao_pagamento) => axios.post(`${API}/processos/${id}/pronto-pagamento`, { fonte_recurso, previsao_pagamento })
export const marcarAprovado = (id) => axios.post(`${API}/processos/${id}/aprovado`)
export const marcarPago = (id, dataPagamento) => axios.post(`${API}/processos/${id}/pago`, dataPagamento ? { data_pagamento: dataPagamento } : {})
export const alterarStatusProcesso = (id, novo_status) => axios.post(`${API}/processos/${id}/alterar-status`, { novo_status })
export const getAgendaPagamentos = (data_inicio, data_fim) => axios.get(`${API}/processos/agenda`, { params: { data_inicio, data_fim } })
export const getDashboardFonteRecurso = () => axios.get(`${API}/processos/dashboard/fonte-recurso`)

export const exportarProcessosExcel = async (params) => {
  const response = await axios.get(`${API}/processos/exportar/excel`, { 
    params,
    responseType: 'blob'
  })
  return response
}

export const exportarProcessosPDF = async (params) => {
  const response = await axios.get(`${API}/processos/exportar/pdf`, { 
    params,
    responseType: 'blob'
  })
  return response
}

export const pagarParcela = (processoId, parcelaNumero, dataPagamento) => axios.post(`${API}/processos/${processoId}/parcela/${parcelaNumero}/pagar`, dataPagamento ? { data_pagamento: dataPagamento } : {})
export const aprovarParcela = (processoId, parcelaNumero) => axios.post(`${API}/processos/${processoId}/parcela/${parcelaNumero}/aprovar`)
export const programarParcela = (processoId, parcelaNumero) => axios.post(`${API}/processos/${processoId}/parcela/${parcelaNumero}/programar`)
export const parcelaProntoPagamento = (processoId, parcelaNumero, data) => axios.post(`${API}/processos/${processoId}/parcela/${parcelaNumero}/pronto-pagamento`, data)
export const retrocederParcela = (processoId, parcelaNumero, novoStatus) => axios.post(`${API}/processos/${processoId}/parcela/${parcelaNumero}/retroceder?novo_status=${novoStatus}`)

// Licitacoes
export const getLicitacoes = (status) => axios.get(`${API}/licitacoes`, { params: { status } })
export const getLicitacao = (id) => axios.get(`${API}/licitacoes/${id}`)
export const createLicitacao = (data) => axios.post(`${API}/licitacoes`, data)
export const updateLicitacao = (id, data) => axios.put(`${API}/licitacoes/${id}`, data)
export const deleteLicitacao = (id) => axios.delete(`${API}/licitacoes/${id}`)
export const getLicitacoesAlertas = () => axios.get(`${API}/licitacoes/alertas`)

// Especialistas
export const getEspecialistas = () => axios.get(`${API}/especialistas`)
export const getEspecialista = (id) => axios.get(`${API}/especialistas/${id}`)
export const createEspecialista = (data) => axios.post(`${API}/especialistas`, data)
export const updateEspecialista = (id, data) => axios.put(`${API}/especialistas/${id}`, data)
export const deleteEspecialista = (id) => axios.delete(`${API}/especialistas/${id}`)
export const registrarConsulta = (id) => axios.post(`${API}/especialistas/${id}/registrar-consulta`)

// Abastecimentos
export const getAbastecimentos = (tipo) => axios.get(`${API}/abastecimentos`, { params: { tipo } })
export const createAbastecimento = (data) => axios.post(`${API}/abastecimentos`, data)
export const updateAbastecimento = (id, data) => axios.put(`${API}/abastecimentos/${id}`, data)
export const deleteAbastecimento = (id) => axios.delete(`${API}/abastecimentos/${id}`)
export const deleteAllAbastecimentos = () => axios.delete(`${API}/abastecimentos`)
export const getAbastecimentosDashboard = () => axios.get(`${API}/abastecimentos/dashboard`)
export const getDashboardSecretaria = () => axios.get(`${API}/abastecimentos/dashboard-secretaria`)
export const importarAbastecimentos = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return axios.post(`${API}/abastecimentos/importar`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
export const downloadModeloAbastecimentos = async () => {
  const response = await axios.get(`${API}/abastecimentos/modelo-planilha`, { responseType: 'blob' })
  return response
}

// Locais de Trabalho
export const getLocaisTrabalho = () => axios.get(`${API}/locais-trabalho`)
export const createLocalTrabalho = (data) => axios.post(`${API}/locais-trabalho`, data)
export const deleteLocalTrabalho = (id) => axios.delete(`${API}/locais-trabalho/${id}`)

// Medicos
export const getMedicos = () => axios.get(`${API}/medicos`)
export const createMedico = (data) => axios.post(`${API}/medicos`, data)
export const deleteMedico = (id) => axios.delete(`${API}/medicos/${id}`)

// Procedimentos
export const getProcedimentos = () => axios.get(`${API}/procedimentos`)
export const createProcedimento = (data) => axios.post(`${API}/procedimentos`, data)
export const deleteProcedimento = (id) => axios.delete(`${API}/procedimentos/${id}`)

// Atendimentos
export const getAtendimentos = () => axios.get(`${API}/atendimentos`)
export const createAtendimento = (data) => axios.post(`${API}/atendimentos`, data)
export const deleteAtendimento = (id) => axios.delete(`${API}/atendimentos/${id}`)

// Indicadores
export const upsertIndicador = (data) => axios.post(`${API}/indicadores`, data)
export const getIndicadores = (ano, categoria) => axios.get(`${API}/indicadores`, { params: { ano, categoria } })
export const getIndicadorComparativo = (ano, categoria) => axios.get(`${API}/indicadores/comparativo`, { params: { ano, categoria } })
export const deleteIndicador = (id) => axios.delete(`${API}/indicadores/${id}`)
